import React, { useMemo } from 'react';
import { Typography } from 'antd';
import dayjs from 'dayjs';
import { useQuery } from '@tanstack/react-query';
import CrudPage from '../../../components/common/CrudPage';
import eventCategoryService from '../../../services/cms/eventCategoryServiceRequest';

const { Text } = Typography;

const QuanLyDanhMucSuKien = () => {
  // Fetch danh sách danh mục để dùng cho dropdown parent_id và mapping tên.
  // Dùng getList thay listActive: list-active bị CORS trên staging, và các trang sự kiện
  // đang dùng chung queryKey này nên phải cùng một dạng dữ liệu trả về.
  const { data: categoriesData } = useQuery({
    queryKey: ['allEventCategories'],
    queryFn: () => eventCategoryService.getList({ page: 1, limit: 1000 }),
  });

  const categoriesList = useMemo(
    () => categoriesData?.data?.data || categoriesData?.data || [],
    [categoriesData]
  );

  // Options cho dropdown parent_id
  const categoryOptions = useMemo(() => {
    return [
      { label: '-- Không có --', value: 0 },
      ...categoriesList.map((item) => ({
        label: `[${item.id}] ${item.title || item.name}`,
        value: item.id,
      })),
    ];
  }, [categoriesList]);

  // Parity CMS cũ: list danh mục lọc được theo danh mục cha (parent_id).
  // Không dùng categoryOptions vì option "-- Không có --" (value 0) chỉ dành cho form.
  const filterFields = useMemo(
    () => [
      {
        label: 'Danh mục cha',
        value: 'parent_id',
        options: [
          { label: 'Tất cả danh mục cha', value: '' },
          ...categoriesList.map((item) => ({
            label: `[${item.id}] ${item.title || item.name}`,
            value: item.id,
          })),
        ],
      },
    ],
    [categoriesList]
  );

  const formFields = [
    {
      name: 'title',
      label: 'Tên danh mục',
      type: 'input',
      rules: [{ required: true, message: 'Vui lòng nhập tên danh mục!' }],
      placeholder: 'Ví dụ: Lễ hội, Kỷ niệm...',
    },
    {
      name: 'parent_id',
      label: 'Danh mục cha',
      type: 'select',
      options: categoryOptions,
      placeholder: 'Chọn danh mục cha (nếu có)',
      propsInput: { showSearch: true, allowClear: true, filterOption: (input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase()) },
    },
    {
      name: 'description',
      label: 'Mô tả',
      type: 'textarea',
      placeholder: 'Mô tả danh mục',
    },
    {
      name: 'alert_info',
      label: 'Thông báo',
      type: 'textarea',
      placeholder: 'Thông tin thông báo (JSON)',
      propsInput: { rows: 2 },
    },
  ];

  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 60,
    },
    {
      title: 'TÊN DANH MỤC',
      dataIndex: 'title',
      key: 'title',
      render: (text) => <Text strong>{text}</Text>,
    },
    {
      title: 'DANH MỤC CHA',
      dataIndex: 'parent_id',
      key: 'parent_id',
      width: 180,
      render: (val, r) => r.parent_id_name ? `[${val}] ${r.parent_id_name}` : (val || '-'),
    },
    {
      title: 'MÔ TẢ',
      dataIndex: 'description',
      key: 'description',
      width: 250,
      ellipsis: true,
    },
    {
      title: 'NGÀY TẠO',
      dataIndex: 'create_time',
      key: 'create_time',
      width: 140,
      render: (time) => (time ? dayjs(time).format('DD/MM/YYYY HH:mm') : '-'),
    },
  ];

  return (
    <CrudPage
      title="QUẢN LÝ DANH MỤC SỰ KIỆN"
      subTitle="Quản lý cấu trúc danh mục sự kiện trong hệ thống"
      itemsName="Danh mục sự kiện"
      queryKey="eventCategoryList"
      service={eventCategoryService}
      columns={columns}
      formFields={formFields}
      filterFields={filterFields}
      searchPlaceholder="Tìm kiếm theo tên danh mục..."
      addButtonLabel="Thêm danh mục"
    />
  );
};

export default QuanLyDanhMucSuKien;
